import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js'
import { themeData } from '../theme-context'
import Checkout from '../components/Checkout'

const stripePromise = loadStripe(themeData.stripe)

const CompleteBooking = () => {
  const { transfers } = useSelector((state: RootState) => state.app)

  const total = Object.values(transfers).reduce((prev, curr) => prev + curr.total, 0)

  const options: StripeElementsOptions = {
    mode: 'payment',
    amount: total,
    currency: 'gbp',
    appearance: {
      theme: 'stripe',
    },
  }

  return (
    <>
      <Elements stripe={stripePromise} options={options}>
        <Checkout />
      </Elements>
    </>
  )
}

export default CompleteBooking
